import React, { useState } from "react";
import Close from "../assets/Close.svg";
const Card = (props) => {
  return (
    <>
      <div className="card">
        <img src={Close} style={{ float: "right" }} onClick={props.close} />
        <p className="cardHeader">Email not correct</p>

        <p className="cardBody">
          The email address you just submitted does not look valid. Please check
          your typo and try again.
        </p>
      </div>
    </>
  );
};

export default Card;
